export const window = {
    redirect,
    reload,
};

/**
 * Redirects the user to the specified URL.
 *
 * Only use this function when you can't use `useNavigate` from 'react-router'.
 * @see `import { useNavigate } from 'react-router';`
 * @see https://reactrouter.com/en/main/hooks/use-navigate
 * @param url - The URL to redirect to.
 */
function redirect(url: string): void {
    global.window.location.href = url;
}

/**
 * reloads the browser window.
 *
 * Only use this function when you can't use `navigate(0)` from `import { useNavigate } from 'react-router'`.
 * @see `import { useNavigate } from 'react-router';`
 * @see https://reactrouter.com/en/main/hooks/use-navigate
 * @param url - The URL to redirect to.
 */
function reload(): void {
    global.window.location.reload();
}
